export const getTruthAndTreasonConfig = () => {
  return {
    grandPrizes: [
      {
        image:
          'https://images.angelstudios.com/image/upload/v1756229156/truth-and-treason/Giveaway-Prize-Image_Historical-Spot_1.webp',
        alt: 'A 10-day / 9-night trip for two to Europe (Germany and additional WWII resistance sites.',
        title: 'A 10-day / 9-night trip for two to Europe (Germany and additional WWII resistance sites)',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1756229156/truth-and-treason/Giveaway-Prize-Image_Plane_1.webp',
        alt: 'Round-trip economy airfare from the U.S. to Europe',
        title: 'Round-trip economy airfare from the U.S. to Europe',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1756229156/truth-and-treason/Giveaway-Prize-Image_Hotel_1.webp',
        alt: 'Hotel accommodations (double occupancy)',
        title: 'Hotel accommodations (double occupancy)',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1756485958/truth-and-treason/Giveaway-Prize-Image_Location3.webp',
        alt: 'Guided tours and city experiences',
        title: 'Guided tours and city experiences',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1756229156/truth-and-treason/Giveaway-Prize-Image_Plane_1.webp',
        alt: 'Transportation between stops (trains or chauffeured vehicles)',
        title: 'Transportation between stops (trains or chauffeured vehicles)',
      },
    ],
  }
}
